module.exports = __webpack_public_path__ + "img/Inflammation-GBM_SPATA.6855cdd9.png";